import React from "react";
import { Table } from "semantic-ui-react";
import PropTypes from "prop-types";

export const DatatableRow = (props) => (
  <Table.Row>
    <Table.Cell>
      <span>
        <a
          onClick={() => props.deleteMember(props.list.id)}
          title="Delete"
          className="btn btn-icon gray"
        >
          <i className="la la-trash"></i>
        </a>{" "}
      </span>
      <span>
        <a
          onClick={() => props.editMember(props.list.id)}
          title="Edit"
          className="btn btn-icon gray"
        >
          <i className="la la-edit blue"></i>
        </a>{" "}
      </span>
    </Table.Cell>
    <Table.Cell>
      {props.list.notification_type == 1 ? "All notifications" : "Schedule based"}
    </Table.Cell>
    <Table.Cell>{props.list.name}</Table.Cell>
    <Table.Cell>
      {props.list.email}
      {props.list.email && props.list.phone_number ? "/" : ""}
      {props.list.phone_number}
    </Table.Cell>
    <Table.Cell key={props.list?.id}>
      <div style={{ display: "flex", columnGap: 10, alignItems: "center" }}>
        <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <input
            disabled
            checked={
              Array.isArray(props.list.notify_via)
                ? props.list.notify_via.includes("email")
                : (props.list.notify_via || "").includes("email")
            }
            type="checkbox"
            readOnly
            style={{ margin: 0 }}
          />{" "}
          Email
        </span>
        {!props.isPLG && (
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <input
              disabled
              checked={
                Array.isArray(props.list.notify_via)
                  ? props.list.notify_via.includes("text")
                  : (props.list.notify_via || "").includes("text")
              }
              type="checkbox"
              readOnly
              style={{ margin: 0 }}
            />{" "}
            Text
          </span>
        )}
        {!props.isPLG && (
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <input
              disabled
              checked={
                Array.isArray(props.list.notify_via)
                  ? props.list.notify_via.includes("phonecall")
                  : (props.list.notify_via || "").includes("phonecall")
              }
              type="checkbox"
              readOnly
              style={{ margin: 0 }}
            />{" "}
            Phone Call
          </span>
        )}
      </div>
    </Table.Cell>
    <Table.Cell>{props.list.user_notification_values}</Table.Cell>
  </Table.Row>
);

DatatableRow.propTypes = {
  list: PropTypes.object.isRequired,
  editMember: PropTypes.func.isRequired,
  deleteMember: PropTypes.func.isRequired,
  isPLG: PropTypes.bool,
};
